import { Box, Flex } from '@chakra-ui/react'
import {
  useDailyEvent,
  useParticipantIds,
  useScreenShare
} from '@daily-co/daily-react'
import React, { useCallback, useEffect, useMemo } from 'react'
import {
  ClientTranscriptionIndicator,
  ClinicianTranscriptionIndicator
} from '../components'
import { useActiveTelehealthSession } from '../context/active-telehealth-session.context'

import { GalleryLayout } from './gallery-layout'
import { SpotlightLayout } from './spotlight-layout'

export const LayoutManager = React.memo(
  () => {
    const { currentLayout, isCallOwner, setLayout } =
      useActiveTelehealthSession()
    const { screens } = useScreenShare()

    const participantIds = useParticipantIds()

    const isScreenSharing = useMemo(() => {
      return screens.length > 0
    }, [screens.length])

    useEffect(() => {
      if (currentLayout.name === 'spotlight' && isScreenSharing) {
        setLayout({
          name: 'gallery',
          isUserSet: false
        })
      } else if (
        currentLayout.name === 'gallery' &&
        participantIds.length <= 2 &&
        !isScreenSharing
      ) {
        setLayout({
          name: 'spotlight',
          isUserSet: false
        })
      }
    }, [isScreenSharing])

    useEffect(() => {
      if (participantIds.length <= 2 && !isScreenSharing) {
        setLayout({
          name: 'spotlight',
          isUserSet: false
        })
      } else if (participantIds.length > 2 && !currentLayout.isUserSet) {
        setLayout({
          name: 'gallery',
          isUserSet: false
        })
      }
    }, [participantIds.length])

    return (
      <Box
        w="100%"
        h="100%"
        p={{
          base: '8px',
          md: '16px'
        }}
      >
        <Flex
          w="100%"
          h="100%"
          justify="center"
          align="center"
          position="relative"
        >
          {isCallOwner ? (
            <ClinicianTranscriptionIndicator />
          ) : (
            <Box position="absolute" top="0px" left="0px" zIndex={100}>
              <ClientTranscriptionIndicator />
            </Box>
          )}
          {currentLayout.name === 'gallery' && <GalleryLayout />}
          {currentLayout.name === 'spotlight' && <SpotlightLayout />}
        </Flex>
      </Box>
    )
  },
  () => true
)
